  <div class="row">
  <div class="col-lg-1 col-12">
      <app-uiform-side-menu
        [uiformId]="uiformId"
        targetId="info"
        [usecaseId]="usecaseId"
        [appId]="appId"
      >
      </app-uiform-side-menu>
    </div>
  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-title border-0 mb-3">
          <div
            class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
          >
            <mat-icon color="primary">info</mat-icon>
            <p class="text-break text-wrap mb-0">
              {{ form.data["title"] }} >
              {{ "UIFORM.INFO.BREADCRUMB" | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-auto mt-1">
        <div class="card shadow-sm border-0">
            <div class="card-header">
            <div class="d-flex justify-content-between align-items-center p-2">
              <div>
                <h6 class="card-title mb-1">{{ form.data["title"] }}</h6>
                <p class="mb-0 small">{{ form.data["description"] }}</p>
              </div>
              <span class="badge bg-secondary rounded-pill px-3 py-2">
                <i class="bi bi-fields me-1"></i>
                {{ form.data["fields"]?.length || 0 }}
                {{ "UIFORM.INFO.FIELDS_COUNT" | translate }}
              </span>
            </div>
            </div>

          <div class="card-body p-4">
              <div *ngIf="form.data['id'] > 0">
              <div class="table-container">
                <div class="table-responsive table-scrollable">
                  <table
                    class="table table-bordered table-hover table-sticky-header"
                  >
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ "UIFORM.INFO.TABLE.SR_NO" | translate }}
                        </th>
                        <th>{{ "UIFORM.INFO.TABLE.LABEL" | translate }}</th>
                        <th>{{ "UIFORM.INFO.TABLE.CODE" | translate }}</th>
                        <th>{{ "UIFORM.INFO.TABLE.TYPE" | translate }}</th>
                        <th>{{ "UIFORM.INFO.TABLE.REQUIRED" | translate }}</th>
                        <th>{{ "UIFORM.INFO.TABLE.UNIQUE" | translate }}</th>
                        <th>{{ "UIFORM.INFO.TABLE.VERSION" | translate }}</th>
                        <th>
                          {{ "UIFORM.INFO.TABLE.EXTRA_DETAILS" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let field of form.data['fields']; let i = index"
                      >
                        <ng-container
                          *ngIf="
                            getAttributeById(field.id) as e;
                            else fallbackRow
                          "
                        >
                          <td class="text-center">{{ i + 1 }}</td>
                          <td>{{ e.label }}</td>
                          <td>
                            <span class="font-monospace">{{ e.code }}</span>
                          </td>
                          <td>
                            <span
                              class="badge rounded-pill"
                              [ngClass]="getTypeBadgeClass(e.type)"
                            >
                              {{ "attributeslabel." + e.type | translate }}
                            </span>
                          </td>
                          <td>
                            <span
                              [class]="
                                e.required === 1 ? 'text-danger' : 'text-muted'
                              "
                            >
                              {{
                                (e.required === 1
                                  ? "UIFORM.INFO.BADGE.YES"
                                  : "UIFORM.INFO.BADGE.NO"
                                ) | translate
                              }}
                            </span>
                          </td>
                          <td>
                            <span
                              [class]="
                                e.unique === 1 ? 'text-success' : 'text-muted'
                              "
                            >
                              {{
                                (e.unique === 1
                                  ? "UIFORM.INFO.BADGE.YES"
                                  : "UIFORM.INFO.BADGE.NO"
                                ) | translate
                              }}
                            </span>
                          </td>
                          <td>v{{ e.version }}</td>
                          <td>
                            <span
                              *ngIf="e.minDate || e.maxDate"
                              class="d-block text-muted"
                            >
                              <ng-container *ngIf="e.minDate"
                                >{{ "UIFORM.INFO.EXTRA.MIN" | translate }}:
                                {{ e.minDate }}</ng-container
                              >
                              <ng-container *ngIf="e.minDate && e.maxDate">
                                ·
                  </ng-container>
                              <ng-container *ngIf="e.maxDate"
                                >{{ "UIFORM.INFO.EXTRA.MAX" | translate }}:
                                {{ e.maxDate }}</ng-container
                              >
                            </span>

                            <span
                              *ngIf="e.timeFormat || e.itimeFormat"
                              class="d-block text-muted"
                            >
                              {{ e.timeFormat || e.itimeFormat
                              }}{{
                                "UIFORM.INFO.EXTRA.TIME_FORMAT" | translate
                              }}
                            </span>

                            <span
                              *ngIf="e.defaultToCurrentDate"
                              class="badge bg-success-subtle text-success me-1"
                            >
                              {{ "UIFORM.INFO.EXTRA.DEFAULT_DATE" | translate }}
                            </span>

                            <span
                              *ngIf="
                                e.defaultToCurrentTime ||
                                e.defaultToCurrentItime
                              "
                              class="badge bg-success-subtle text-success me-1"
                            >
                              {{ "UIFORM.INFO.EXTRA.DEFAULT_TIME" | translate }}
                            </span>

                            <span
                              *ngIf="e.defaultToCurrentDateAndTime"
                              class="badge bg-success-subtle text-success me-1"
                            >
                              {{
                                "UIFORM.INFO.EXTRA.DEFAULT_DATETIME" | translate
                              }}
                            </span>

                            <span
                              *ngIf="e.dateTimeFormat"
                              class="d-block text-muted"
                            >
                              {{ "UIFORM.INFO.EXTRA.FORMAT" | translate }}:
                              <span class="font-monospace">{{
                                e.dateTimeFormat
                              }}</span>
                            </span>

                            <span
                              *ngIf="e.allowChangeAfterInitial"
                              class="badge bg-warning-subtle text-warning me-1"
                            >
                              {{
                                "UIFORM.INFO.EXTRA.NO_CHANGE_AFTER_INITIAL"
                                  | translate
                              }}
                            </span>

                            <span
                              *ngIf="e.system"
                              class="badge bg-secondary-subtle text-secondary me-1"
                            >
                              {{ "UIFORM.INFO.EXTRA.SYSTEM_FIELD" | translate }}
                            </span>

                            <span
                              *ngIf="e.depAttribute"
                              class="d-block text-muted"
                            >
                              {{ "UIFORM.INFO.EXTRA.DEPENDS_ON" | translate }}:
                              <span>{{ e.depAttribute }}</span>
                            </span>

                            <span
                              *ngIf="
                                !e.minDate &&
                                !e.maxDate &&
                                !e.timeFormat &&
                                !e.itimeFormat &&
                                !e.defaultToCurrentDate &&
                                !e.defaultToCurrentTime &&
                                !e.defaultToCurrentItime &&
                                !e.defaultToCurrentDateAndTime &&
                                !e.dateTimeFormat &&
                                !e.allowChangeAfterInitial &&
                                !e.system &&
                                !e.depAttribute
                              "
                              class="text-muted"
                              >—</span
                            >
                          </td>
                        </ng-container>

                        <ng-template #fallbackRow>
                          <td class="text-center">{{ i + 1 }}</td>
                          <td colspan="7" class="text-muted fst-italic">
                            {{ "UIFORM.INFO.ATTRIBUTE_NOT_FOUND" | translate }}
                            (id: {{ field.id }})
                          </td>
                        </ng-template>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </div>

            <div
              *ngIf="form.data['id'] === 0 || !form.data['fields']?.length"
              class="text-center text-muted py-4"
            >
              <mat-icon>info_outline</mat-icon>
              <p class="mt-2">{{ "UIFORM.INFO.NO_FIELDS" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
